const store = {
  // Routing
  condition: 'control',   // 'control' | 'T1' | 'T2' | 'T3'
  feedType: 'general',    // 'female' | 'male' | 'general'
  screen: 'feed',         // 'feed' | 'end'
  isTest: false,

  // Video playback
  isMuted: true,

  // Feed tracking
  sessionStartTime: null,
  postsViewed: [],
  harmfulPostsViewed: 0,
  postViewEvents: [],

  // Chatbot (T3)
  chatbotTriggered: false,
  chatbotCompleted: false,
  chatbotAnswers: [],
  exerciseSelected: null,
  exerciseCompleted: false,

  // Reveal questionnaire (T1/T2) – populated later
  revealAnswers: [],
  revealScore: null,
  revealProfileShown: null,
};

export default store;
